import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  padding: .5rem 0;
  align-items: center;
  margin-top: 1rem;
  cursor: pointer;
`;

export const Input = styled.input`
  appearance: none;
  color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  user-select: none;
  flex-shrink: 0;
  height: 22px;
  width: 22px;
  color: #ffffff;
  background-color: transparent;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border: 2px solid #ffffff;
  border-radius: 5px;
  box-shadow: 0px 3px 10px rgba(245, 241, 180, 0.2);
  transition: all 300ms;

  &:checked {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg id='Group_3361' data-name='Group 3361' transform='translate(-355 -469)'%3E%3Cpath id='Path_6444' data-name='Path 6444' d='M7.518,13.394,4.429,10.306,3.4,11.336l4.118,4.118,8.824-8.824L15.312,5.6Z' transform='translate(357.432 471.043)' fill='%23fff' stroke='%23fff' stroke-width='1'/%3E%3C/g%3E%3C/svg%3E%0A");
    border-color: #F66596;
    background-color: #DD1D7D;
    box-shadow: 0px 3px 10px rgba(255, 12, 174, 0.6);
  }
`;

export const Label = styled.span`
  margin-left: 1rem;
  font-size: .9rem;
  color: #CDCCD2;
`;